import React from 'react';
import {DragDropContext, Droppable} from 'react-beautiful-dnd';


const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

class OptionSorter extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      items: props.items
    }
  }

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({
      items,
    });

    this.props.onSortChange(items.map((i) => i.props.option));
  }

  componentWillReceiveProps(nextProps){
    if(this.props.items !== nextProps.items){
      this.setState({
        items: nextProps.items
      })
    }
  }

  render(){
    let items = this.state.items;
    return(
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="user_sort">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ backgroundColor: snapshot.isDraggingOver ? '' : '' }}
            >
              {items}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }

}

export default OptionSorter;
